<template>
    <div>
        <v-form style="margin-top: 20px" class="custom-hide-details-2">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <SelectInput ref="selectInput16" @selectedValues="getQuality" :originalItems="quality"
                        label="الجوده" />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-autocomplete :items="['لا', 'نعم']" label="استلامه من قبل الجوده" @change="sendDataToParent()"
                        v-model="resiveFromQuality" outlined dense>
                        <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-autocomplete :items="['لا', 'نعم']" label="ارشفه من قبل الجوده" @change="sendDataToParent()"
                        v-model="qualityArchive" outlined dense>
                        <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                    <SelectInput ref="selectInput17" @selectedValues="getQualityType" :originalItems="qualityStatus"
                        label="حاله الطلب عند الجوده" />
                </v-col>

                <v-col cols="12" sm="6" md="6">
                    <IncludeDeletedClassificationsToggle v-model="includeDeletedClassifications" />
                </v-col>

                <v-col cols="12" sm="6" md="6">
                    <SelectInput ref="selectInput18" @selectedValues="getVarityQuality" :originalItems="qualityUserType"
                        label="تصنيف الجوده" />
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>


<script>
import SelectInput from "@/components/Charts/SelectInput.vue";
import IncludeDeletedClassificationsToggle from "@/components/Filters/IncludeDeletedClassificationsToggle.vue";
import classificationFilterMixin from "@/mixins/classificationFilterMixin";
import { axiosInstance } from "@/axios/config";

export default {
    components: { SelectInput, IncludeDeletedClassificationsToggle },
    mixins: [classificationFilterMixin],
    data() {
        return {
            classificationFilterTypes: [5],
            qualityUserType: [],
            quality: [],
            selectedQualityUsers: [],
            resiveFromQuality: "",
            qualityArchive: "",
            selectedVarityQuality: [],
            qualityStatus: [],
            selectedQualityStatus: [],
        };
    },

    methods: {
        sendDataToParent() {
            this.$emit("send-quality-data", {
                selectedQualityStatus: this.selectedQualityStatus,
                selectedQualityUsers: this.selectedQualityUsers,
                resiveFromQuality: this.resiveFromQuality,
                qualityArchive: this.qualityArchive,
                selectedVarityQuality: this.selectedVarityQuality,
            });
        },

        getQualityType(val) {
            this.selectedQualityStatus = val;
            this.sendDataToParent();
        },

        getVarityQuality(val) {
            this.selectedVarityQuality = val;
            this.sendDataToParent();
        },
        getQuality(val) {
            this.selectedQualityUsers = val;
            this.sendDataToParent();
        },

        getQualityStatus() {
            let url = "/employee/quality/quality-request/request/status";
            axiosInstance.get(url).then((res) => {
                this.qualityStatus = res.data.payload.map((item) => {
                    item["color"] = "red";
                    item["text"] = item["status_value"];
                    return item;
                });
            });
        },

        getSupAdmin() {
            let url = "/v2/employee/quality-users";
            axiosInstance.get(url).then((res) => {
                this.quality = res.data.payload.map((item) => {
                    item["color"] = "red";
                    item["text"] = item["name_for_admin"];
                    return item;
                });
            });
        },

    },

    mounted() {
        this.reloadAllClassificationsForFilter().finally(() => {
            this.enableClassificationFilterWatchAfterInitialLoad();
        });
        this.getQualityStatus();
        this.getSupAdmin();
    },

};
</script>
